import React from 'react';
import PropTypes from 'prop-types';
import { isPrimitive } from 'modules/Utils/isPrimitive';
import { Icon } from 'modules/Core/Common/Icon';
import * as S from './styles';
import i18n from 'i18next';

const Select = ({
  children,
  options = [],
  optionText,
  optionValue,
  placeholder = '',
  hidePlaceholder = true,
  className,
  loading,
  prependInnerIcon,
  ...rest
}) => (
  <S.Container className={className} prependInnerIcon={prependInnerIcon}>
    {children}
    {prependInnerIcon && <Icon name={prependInnerIcon} />}
    <S.SelectField prependInnerIcon={prependInnerIcon} {...rest}>
      {!loading && placeholder && (
        <option hidden={hidePlaceholder}>{placeholder}</option>
      )}
      {loading && (
        <option value="" hidden>
          {`${i18n.t('common-words.loading')}...`}
        </option>
      )}
      {options.map((option, index) => {
        const optionKey = isPrimitive(option)
          ? `${index}-${option}`
          : `${option?.[optionValue]}-${option?.[optionText]}`;
        return (
          <option
            key={optionKey}
            value={isPrimitive(option) ? option : option?.[optionValue]}
            disabled={option?.disabled}
          >
            {isPrimitive(option) ? option : option?.[optionText]}
          </option>
        );
      })}
    </S.SelectField>
    <Icon color="#5D6670" name="arrow-down" />
  </S.Container>
);

Select.defaultProps = {
  optionValue: 'id',
  optionText: 'name',
};

Select.propTypes = {
  options: PropTypes.array.isRequired,
  optionText: PropTypes.string,
  optionValue: PropTypes.string,
  placeholder: PropTypes.string,
  hidePlaceholder: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.element,
  loading: PropTypes.bool,
  prependInnerIcon: PropTypes.string,
};

export { Select };
